// extracted by mini-css-extract-plugin
export var a_button = "offer-module--a_button--9PBJo";
export var offer = "offer-module--offer--v7Pe8";
export var offer_details = "offer-module--offer_details--jd7DK";
export var preview = "offer-module--preview--Tgcm0";
export var title = "offer-module--title--Pwt1h";